import { mutator } from 'satcheljs';
import updateUserConfigurationPont from '../actions/actionCreators/updateUserConfigurationPont';
import { getUserConfiguration } from 'owa-session-store';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';

export { default as PontType } from 'owa-service/lib/contract/PontType';

export default mutator(updateUserConfigurationPont, actionMessage => {
    getUserConfiguration().UserOptions.NewEnabledPonts &= ~actionMessage.pontType;

    updateUserConfiguration('OWA.UserOptions', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['NewEnabledPonts'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'Integer32',
                Value: [`${getUserConfiguration().UserOptions.NewEnabledPonts}`],
            }),
        }),
    ]);
});
